// Common
import connect from '../../../../store/connect';
import connectOctopus from '../../../../store/connect-octopus';
import { getEnhance, FEATURE_NAME, namespace } from './gallery';
import experimentSelector from '../../../../components/experiment-selector';
import * as actions from '../../../../actions/vip';

// Component
import GalleryWrapper from '../../../../components/gallery';
import jsonToPropsComponent from '../../../../components/gallery/json-to-props';

// ComponentWithExperiment
import { withPlugins } from '../../../../utils/octopus';
import {
  GalleryDesktop,
  PluginClipsDesktop as clipsPlugin,
} from '../../../../components/gallery-with-plugins/gallery.desktop';
import jsonToPropsWithExperiment from '../../../../components/gallery-with-plugins/helpers/json-to-props';

const mapStateToProps = jsonToProps => (
  {
    components: {
      fixed: { [FEATURE_NAME]: gallery },
      header: { title },
    },
  },
  ownProps,
) => ({ ...jsonToProps({ ...gallery, titleForAlt: title }), ...ownProps });
/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  showSnackbar: props => dispatch(actions.showSnackbar({ ...props })),
});

const enhance = getEnhance(
  connect(
    mapStateToProps(jsonToPropsComponent),
    mapDispatchToProps,
  ),
);

const enhanceWithExperiment = getEnhance(
  connectOctopus(
    mapStateToProps((...args) => ({
      ...jsonToPropsWithExperiment(...args),
      namespace,
    })),
    mapDispatchToProps,
  ),
);

const Component = enhance(GalleryWrapper);

const ComponentWithExperiment = enhanceWithExperiment(withPlugins(clipsPlugin)(GalleryDesktop));

export default experimentSelector({
  experimentName: 'octopus-gallery-plugin',
  Component,
  ComponentWithExperiment,
});
